import React from "react"
import ListLink from "./list-link"

export default () => (
    <div className="nav">
        <div className="nav-item"><ListLink to="/">Home</ListLink></div>
        <div className="nav-item"><ListLink to="/experience">Experience</ListLink></div>
        <div className="nav-item"><ListLink to="/contact">Contact</ListLink></div>
    </div>
)